import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from "styled-components";
import { DEFAULT_PADDING, LG_PADDING, MEDIUM_FONT_WEIGHT, SM_FONT_SIZE, WHITE_COLOR, XL_FONT_SIZE, XS_FONT_SIZE } from '../Common/StyleElement';

export const Bar = styled.div`
  border-left: 2px solid #000;
  height: auto;
  margin: 0 15px;
`

export const Foot = styled.footer`
  display: flex;
  align-items: center;
  width: 100%;
  height: 200px;
  background: ${WHITE_COLOR};
  font-weight: ${MEDIUM_FONT_WEIGHT};
  border-top: solid;
  border-top-width: 1px;
  border-top-color: rgba(124, 139, 161, 0.1);
`

export const FooterCenterCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FooterCopyright = styled.p`
  font-size: ${XS_FONT_SIZE};
`

export const FooterLogo = styled(Link)`
  cursor: pointer;
  display: flex;
  font-weight: bold;
  text-decoration: none;
  z-index: 1;
  padding-bottom: ${LG_PADDING};
  color: #000;
  font-size: ${XL_FONT_SIZE};
  &:hover {
      color: #000;
  }
`

export const FooterMenu = styled.ul`
    display: flex;
    flex-direction: row;
    list-style: none;
    text-align: center;
    padding: 0 0 ${DEFAULT_PADDING} 0;
`

export const FooterLink = styled(Link)`
  font-size: ${SM_FONT_SIZE};
  font-weight: ${MEDIUM_FONT_WEIGHT};
  color: #000;
  margin: 0 15px;
  transition-duration: 300ms;
  &::after {
    content: "";
    display: block;
    margin: auto;
    height: 2px;
    width: 0;
    background: transparent;
    transition: width 500ms ease;
  }
  &:hover {
    color: #000;
  }
  &:hover::after {
    width: 100%;
    background: #000;
  }
`

export const FooterA = styled.a`
  font-size: ${SM_FONT_SIZE};
  font-weight: ${MEDIUM_FONT_WEIGHT};
  color: #000;
  margin: 0 15px;
  transition-duration: 300ms;
  &::after {
    content: "";
    display: block;
    margin: auto;
    height: 2px;
    width: 0;
    background: transparent;
    transition: width 500ms ease;
  }
  &:hover {
    color: #000;
  }
  &:hover::after {
    width: 100%;
    background: #000;
  }
`